import { Badge } from '@/components/ui/badge';


const SOURCE_LABELS = {
  db_field: 'DB',
  composed_runtime: 'Runtime',
  system_runtime: 'Sistema',
  derived_total: 'Derivado',
  template_discovery: 'Detectado',
  custom_entry: 'Custom',
};

const EDITABILITY_LABELS = {
  directly_editable: 'Editável',
  editable_in_parent_module: 'Editável na origem',
  derived_only: 'Só derivado',
  system_generated: 'Gerado pelo sistema',
  unknown: 'Origem incerta',
};

const STABILITY_LABELS = {
  canonical: 'Canónico',
  legacy: 'Legacy',
  experimental: 'Experimental',
};

const KIND_LABELS = {
  field: 'Campo',
  datasource: 'Tabela',
  computed_line: 'Linha derivada',
  computed_value: 'Total derivado',
  system_runtime: 'Runtime',
};

const STABILITY_CLASSNAMES = {
  canonical: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  legacy: 'bg-amber-100 text-amber-900 border-amber-200',
  experimental: 'bg-fuchsia-100 text-fuchsia-900 border-fuchsia-200',
};

export const CatalogContractBadges = ({ item, testIdBase = 'catalog-contract' }) => {
  if (!item) return null;

  return (
    <div className="flex flex-wrap gap-1" data-testid={`${testIdBase}-wrapper`}>
      <Badge variant="secondary" className="px-1 py-0 text-[8px]" data-testid={`${testIdBase}-kind`}>
        {KIND_LABELS[item.contract_kind] || item.contract_kind || item.kind || 'Campo'}
      </Badge>
      <Badge variant="outline" className="px-1 py-0 text-[8px]" data-testid={`${testIdBase}-module`}>
        {item.origin_context || item.module || 'GLOBAL'}
      </Badge>
      <Badge variant="outline" className="px-1 py-0 text-[8px]" data-testid={`${testIdBase}-source-origin`}>
        {SOURCE_LABELS[item.source_origin] || item.source_origin || 'Origem'}
      </Badge>
      <Badge variant="outline" className="px-1 py-0 text-[8px]" data-testid={`${testIdBase}-editability`}>
        {EDITABILITY_LABELS[item.editability] || item.editability || 'Editabilidade'}
      </Badge>
      <Badge className={`px-1 py-0 text-[8px] ${STABILITY_CLASSNAMES[item.stability] || 'bg-slate-100 text-slate-800 border-slate-200'}`} data-testid={`${testIdBase}-stability`}>
        {STABILITY_LABELS[item.stability] || item.stability || 'Estado'}
      </Badge>
    </div>
  );
};